<template>
  <!--
  <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div>
  -->
  <router-view/>
</template>

<script>

// import { useSanityClient } from 'vue-sanity'

export default {
  name: 'App',
  //setup() {
    //useSanityClient({
      //projectId: 'p5dh9qkt',
      //dataset: 'production',
      //useCdn: process.env.NODE_ENV === 'production',
    //})
  //},
}

</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
